export { default } from './ReCaptchaScript';
